<template>
  <div>
    <ml-header title="PP视频用户协议" :dark="true" background-color="#fff" />
    <div class="protocol-page">
      <h1>一、账号注册</h1>
      <p>
        1、用户在使用本服务前需要注册一个“陌陌”帐号。“陌陌”帐号应当使用手机号码绑定注册，请用户使用尚未与“陌陌”帐号绑定的手机号码，以及未被陌陌科技根据本协议封禁的手机号码注册“陌陌”帐号。陌陌科技可以根据用户需求或产品需要对帐号注册和绑定的方式进行变更，而无须事先通知用户。
        对您的手机号认证成功，则您的注册即完成。如您不同意对运营商的授权和/或服务条款或者是您的手机号认证失败，您可以手动修改运营商提取的手机号码，采取验证码方式进行注册登录。
        的使用体验。陌陌科技搜集的信息包括但不限于用户的属行业、兴趣爱好、常出没的地方、个人说明；陌陌科技同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。
      </p>
      <h1>二、服务内容</h1>
      <p>
        1、用户在使用本服务前需要注册一个“陌陌”帐号。“陌陌”帐号应当使用手机号码绑定注册，请用户使用尚未与“陌陌”帐号绑定的手机号码，以及未被陌陌科技根据本协议封禁的手机号码注册“陌陌”帐号。陌陌科技可以根据用户需求或产品需要对帐号注册和绑定的方式进行变更，而无须事先通知用户。
        对您的手机号认证成功，则您的注册即完成。如您不同意对运营商的授权和/或服务条款或者是您的手机号认证失败，您可以手动修改运营商提取的手机号码，采取验证码方式进行注册登录。
        的使用体验。陌陌科技搜集的信息包括但不限于用户的属行业、兴趣爱好、常出没的地方、个人说明；陌陌科技同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Protocol"
};
</script>

<style lang="scss" scoped>
.protocol-page {
  padding: 40px 15px;
  display: flex;
  flex-direction: column;
  text-align: left;
  > h1 {
    margin: 30px 0;
    font-size: 14px;
    font-weight: 600;
  }
  > p {
    font-size: 14px;
    line-height: 29px;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
